import axiosClient from "api/axiosClient";
import API_MAP from "constants/api";

class ApiManagerStorage{
    getParticipantsSharedStorage = () => {
        return axiosClient.get(API_MAP.GET_PARTICIPANTS_SHARED_STORAGE);
    }
    inviteUsingSharedStorage = (object) => {
        return axiosClient.post(API_MAP.INVITE_USING_SHARED_STORAGE, object)
    }
    getListInvitations = () => {
        return axiosClient.get(API_MAP.GET_LIST_INVITATIONS);
    }
    responseInvitation = (ownerId, status) => {
        return axiosClient.post(API_MAP.RESPONSE_INVITATION, {owner_id: ownerId, status: status});
    }
    retrieveInvitation = (ownerId, sharedUserId) => {
        return axiosClient.post(API_MAP.RETRIEVE_INVITATION, {owner_id: ownerId, shared_user_id: sharedUserId})
    }
    getStatisticStorage = () => {
        return axiosClient.get(API_MAP.GET_STATISTIC_STORAGE)
    }
}

const apiManagerStorage = new ApiManagerStorage();

export default apiManagerStorage;